import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../../components/Button';
import './styles.css';

const TokenExpirado: React.FC = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`body-wrapper auth-wrapper d-flex align-items-stretch ${darkMode ? 'dark-mode' : ''}`}>
      <div className="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
        <div className="auth-panel-wrapper col">
          <div className="auth-panel py-5 text-center">
            <img 
              src="/logo-trading.png" 
              alt="Trading Logo"
            />
            <div className="auth-header mt-4">
              <h4 className="auth-title">Link expirado</h4>
              <p className="auth-subtitle">
                O link de confirmação expirou ou já foi utilizado.
                Por favor, crie uma nova conta para continuar.
              </p>
            </div>
            <Button 
              type="button" 
              variant="auth" 
              fullWidth 
              onClick={() => navigate('/cadastrar')}
              className="mt-4"
            >
              Criar nova conta
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenExpirado;
